<template>
    <div id="contenedor-auditorias-tablero">
      <v-container fluid>
        <v-card flat class="mb-4 rounded-lg">
          <v-card-text class="px-0 py-1">
            <TituloToolBar
            titulo="Estatus de Auditorias"
            nombreRuta="auditorias"
            regresar>
            <!-- <template v-slot:opciones-derecha>
              <v-menu
                v-model="mostrarMenuExportar"
                :close-on-content-click="false"
                offset-y>
                  <template v-slot:activator="{ on: onMenu }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on: onTooltip }">
                      <v-btn icon
                      v-on="{ ...onMenu, ...onTooltip }">
                    <v-icon> mdi-export-variant </v-icon>
                      </v-btn>
                    </template>
                    <span>Exportar</span>
                  </v-tooltip>
                </template>
                <v-list>
                  <ExcelObservaciones
                  listItem/>
                </v-list>
              </v-menu>
            </template> -->
          </TituloToolBar>
          <ToolBar
          :filtros="filtros" />
          </v-card-text>

        </v-card>
        <v-card flat>
          <v-card-text>
            <TableroObservaciones
            :filtros="filtros" />
            <v-divider class="my-4"></v-divider>
            <TableroResumenAuditorias
            :filtros="filtros" />
          </v-card-text>
        </v-card>
      </v-container>
    </div>
</template>

<script>
import TituloToolBar from '@/components/TituloToolBar.vue';
import TableroResumenAuditorias from '@/components/administracion/auditorias/tableros/TableroResumen.vue';
// import ExcelObservaciones from '@/components/exportar/exceles/ExcelObservacionesAuditorias.vue';
import TableroObservaciones from '@/components/administracion/auditorias/tableros/TableroObservaciones.vue';
import ToolBar from './ToolBar.vue';

export default {
  name: 'TableroAuditorias',
  components: {
    TituloToolBar,
    TableroResumenAuditorias,
    // ExcelObservaciones,
    TableroObservaciones,
    ToolBar,
  },
  data() {
    return {
      mostrarMenuExportar: false,
      filtros: {
        ejercicioDel: new Date().getFullYear(),
        ejercicioAl: new Date().getFullYear(),
        enteFiscalizador: null,
        auditoriaSelected: null,
        auditorias: [],
      },
    };
  },
};
</script>

<style lang="scss" scoped>

</style>
